import { isValid as isValidFns } from 'date-fns';

export default function isValid(date: Date | string): boolean {
  return isValidFns(date);
}
